import { ReactComponent as LocationIcon } from 'assets/icons/location.svg'
import Select from 'components/Select'
import useEnforceOtcLocation from 'hooks/useEnforceOtcLocation'
import { useTPCacheContext } from 'providers/TPCacheProvider'
import { usePlusClient } from 'providers/VisionRouter'

interface inputProps {
  limitedLocations?: [string]
  disableAll?: boolean
  disabled?: boolean
}

const LocationSelectorDropDown = (props: inputProps): JSX.Element => {
  const { limitedLocations, disableAll, disabled } = props
  const {
    currentLocation: { queryMap },
    routeToMergedQuery,
  } = usePlusClient()
  const { locations, getLocationNameById } = useTPCacheContext()

  useEnforceOtcLocation()

  const locationId = queryMap?.locationId || queryMap?.locationIds?.[0] || ''
  const locationNameFromUrl = getLocationNameById(locationId)

  const matchedLocations = limitedLocations
    ? locations.filter(location => limitedLocations.includes(location._id))
    : locations

  if (!matchedLocations.length) {
    // This reduces UI element jumping around during first load.
    return <Select options={[]} placeholder="Location" />
  }

  const locationOptions = [...matchedLocations]
    .filter(location => !!location.active)
    .sort((a, b) => a.name.localeCompare(b.name))
    .map(location => ({ label: location.name, value: location._id }))

  if (!disableAll) locationOptions.unshift({ label: 'All', value: '' })
  const value = { value: locationId, label: locationNameFromUrl || 'All' }

  return (
    <Select
      data-testid="locations"
      disabled={disabled}
      fadePlaceholderText={false}
      hotKey="l"
      options={locationOptions}
      value={value}
      placeholder="Location"
      icon={<LocationIcon />}
      onChange={([option]) => {
        const selectedLocationId = option?.value || undefined

        if (selectedLocationId !== locationId) {
          routeToMergedQuery({
            locationId: !selectedLocationId ? undefined : selectedLocationId,
            locationIds: !selectedLocationId ? undefined : [selectedLocationId],
            page: 0,
          })
        }
      }}
      showActive={!!locationNameFromUrl}
      disableClear={true}
      showLoadingAnimation={locationOptions.length <= 1}
    />
  )
}

export default LocationSelectorDropDown
